//ReactEcharts
import ReactEcharts from "echarts-for-react";

// react-router-dom components

// mui components

// mui-icons components

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

//routes

//assets

//utils
import { AppendStatsToCharts } from "../../../utils/AppendStatsToCharts";

function PieCharts({ data = [] }) {
    const seriesData = AppendStatsToCharts(data);

    const option = {
        tooltip: {
            trigger: "item",
            confine: true,
            formatter: function (params) {
                let tooltipText = `<div style ="text-align: left; ">${params.name}: ${params.value}`;
                if (params.data && Object.keys(params.data).includes("details") && params.data.details) {
                    tooltipText += params.data.details.map((detail) => `<br/>${detail.name} : <span style={{fontWeight: 600}}>${detail.value}</span>`).join("");
                }
                tooltipText += `</div>`;
                return tooltipText;
            },
            textStyle: {
                fontSize: 12,
            },
        },
        legend: {
            top: "top",
            type: "scroll",
            selectedMode: false,
        },
        series: [
            {
                type: "pie",
                radius: "45%",
                data: seriesData,
                center: ["50%", "55%"],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                },
            },
        ],
    };

    return (
        <div style={{ overflow: "auto" }}>
            <ReactEcharts
                option={option}
                style={{ minWidth: "360px", minHeight: "240px", height: "400px" }}
                opts={{ renderer: "svg" }}
            />
        </div>
    );
}

// Typechecking props for the PieCharts
PieCharts.propTypes = {
    data: PropTypes.array,
};

export default PieCharts;
